import React from "react";
import { observer } from "mobx-react";
import { DashboardWidgetViewStore } from "../../store";
import { DashboardWidgetViewForm } from "./DashboardWidgetViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type DashboardWidgetViewProps = {
  dashboardWidgetViewStore: DashboardWidgetViewStore;
};

export const DashboardWidgetView: React.FC<DashboardWidgetViewProps> = observer(
  ({ dashboardWidgetViewStore }) => {
    return (
      <div>
        <DashboardWidgetViewForm
          widgetKey={dashboardWidgetViewStore.widgetKeyValue}
          title={dashboardWidgetViewStore.titleValue}
          description={dashboardWidgetViewStore.descriptionValue}
          category={dashboardWidgetViewStore.categoryValue}
          component={dashboardWidgetViewStore.componentValue}
          dataFetcherKey={dashboardWidgetViewStore.dataFetcherKeyValue}
          defaultConfig={dashboardWidgetViewStore.defaultConfigValue}
          icon={dashboardWidgetViewStore.iconValue}
          minWidth={dashboardWidgetViewStore.minWidthValue}
          minHeight={dashboardWidgetViewStore.minHeightValue}
          refreshInterval={dashboardWidgetViewStore.refreshIntervalValue}
          requiredPermissions={
            dashboardWidgetViewStore.requiredPermissionsValue
          }
          enabled={dashboardWidgetViewStore.enabledValue}
          onPrint={(handlePrint: () => void) =>
            dashboardWidgetViewStore.printDashboardWidget(handlePrint)
          }
          onCancel={() => dashboardWidgetViewStore.cancelDashboardWidget()}
          onEdit={
            dashboardWidgetViewStore.isEditEnabled
              ? () => dashboardWidgetViewStore.editDashboardWidget()
              : undefined
          }
        />
        <ErrorDialog
          open={dashboardWidgetViewStore.errorDialogOpened}
          title={dashboardWidgetViewStore.errorTitle}
          description={dashboardWidgetViewStore.errorDescription}
          onClose={() => dashboardWidgetViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
